import {MotivatorsTypes} from 'domain/usecases';

export enum RatingStatusEnum {
	NOT_EVALUATED = '0',
	EVALUATED = '1',
	NEVER_EVALUTE = '4',
}

export type FiveStarsItems = {
	avaliacao: string;
	canal: string;
	cdatendimento: string;
	cdusuario: string;
	dtinsercao: string;
	email: string;
	origem: string;
	status: RatingStatusEnum | string;
	tipo: MotivatorsTypes | string;
};

export type Evaluation = {
	nota: number | null;
	id_motivador: string;
	nota_negativa?: NegativeEvaluation[];
};

export type NegativeEvaluation = {
	id_quest_3estrelas_abaixo: number;
	resposta: string;
};

export type PostFiveStarsParams = {
	items: FiveStarsItems[];
};

export type PostFiveStarsModel = {
	links: {
		self: string;
	};
	requestToken: string;
	tokenExpireDateUtc: string;
	customObjectId: string;
	customObjectKey: string;
	pageSize: number;
	page: number;
	count: number;
	top: number;
};

export interface PostFiveStars {
	post: (params: PostFiveStarsParams) => Promise<PostFiveStarsModel>;
}
